import {useMemo, useState} from "react";
import {useSelector} from "react-redux";
import {useSwitchView} from "./useSwitchView";
import {supportedLanguages} from "../i18n";
import {useTranslation} from "react-i18next";

export const useNavPanelDeps = ({clearStateHandler}) => {
    const {t} = useTranslation();
    const {userData} = useSelector(state => state.userProfile.getUserProfile);
    const {logoutActive} = useSelector(state => state.login.logoutFetch);
    const {navPanelCollapsed, chosenLanguage} = useSelector(state => state.globalParams.globalParams);
    const [isLogoutHovered, setIsLogoutHovered] = useState(false);
    const hasAccessToDashboard = userData?.roles?.some(role => [2, 3].includes(role.id));
    const handleSwitchView = useSwitchView({clearStateHandler: clearStateHandler});
    const languages = useMemo(
        () => Object.keys(supportedLanguages)
            .map(value => ({value, label: t(value), collapsedLabel: t(`${value}Short`)})),
        [t]
    );

    return {
        logoutActive: logoutActive,
        navPanelCollapsed: navPanelCollapsed,
        chosenLanguage: chosenLanguage,
        isLogoutHovered: isLogoutHovered,
        setIsLogoutHovered: setIsLogoutHovered,
        hasAccessToDashboard: hasAccessToDashboard,
        handleSwitchView: handleSwitchView,
        languages: languages,
    }
}